import { Banner } from 'views/user-verification';
import './complex-onboarding-flow.scss';
import { RightFlowContainer } from './components';
import { useComplexOnboarding } from './hooks';

export const ComplexOnboardingFlow = ({ handleOnDrop }: any) => {
	const { bannerStatus, isIframeOpen, background } = useComplexOnboarding();

	return (
		<div
			id="complex-onboarding-main"
			className="OnboardingFlow--container"
			style={{ backgroundColor: background }}
		>
			{/* Header rendered once, by the parent views/onboarding-flow/onboarding-flow.tsx */}
			{bannerStatus === false && <Banner />}

			{/* UI Wrapper */}
			<div
				className="OnboardingFlow--contain"
				style={{
					...(isIframeOpen && {
						marginTop: 0,
					}),
				}}
			>
				<RightFlowContainer handleOnDrop={handleOnDrop} />
			</div>
		</div>
	);
};
